// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  //** Local Base URL */
  // 31oct23

    /** DEV/LOCAL Development Base URL */
    //baseUrl: 'http://localhost:5001/api',
  
  /**PRODUCTION Base URL New  */
  baseUrl: 'https://iodssapi.mahindraglobaldms.com/api',

  firebase: {
    apiKey: "AIzaSyCWJlSBF1hK9D77KpdT9zear2KojDSzHFI",
    authDomain: "mahindra-dss-dc940.firebaseapp.com",
    databaseURL: "https://mahindra-dss-dc940.firebaseio.com",
    projectId: "mahindra-dss-dc940",
    storageBucket: "mahindra-dss-dc940.appspot.com",
    messagingSenderId: "986520887994"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
